import React, { useState } from "react";
import { Copy, MonitorPlay, Broadcast, User, UsersThree, Table, SlidersHorizontal } from "@phosphor-icons/react";
import { toast } from "sonner";

function OverlayCard({ title, description, path, Icon, testId }) {
  const url = `${window.location.origin}${path}`;
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    try { await navigator.clipboard.writeText(url); setCopied(true); toast.success("Link copied"); setTimeout(() => setCopied(false), 1500); }
    catch (e) { toast.error("Copy failed"); }
  };
  return (
    <div className="bg-white border border-gray-200 rounded p-5 flex flex-col" data-testid={testId}>
      <div className="flex items-center gap-3 mb-3">
        <div className="w-11 h-11 grid place-items-center rounded bg-blue-500/10 border border-blue-500/30">
          <Icon size={22} className="text-blue-600" />
        </div>
        <div>
          <div className="font-display text-xl uppercase leading-none">{title}</div>
          <div className="label-mono">Shareable public link</div>
        </div>
      </div>
      <p className="text-sm text-gray-500 mb-4">{description}</p>
      <div className="flex-1" />
      <div className="flex gap-2 mt-2">
        <input value={url} readOnly className="flex-1 bg-slate-50 border border-gray-200 rounded px-3 py-2 text-xs font-mono text-gray-600" />
        <button onClick={copy} className="btn-ghost text-xs !px-3">{copied ? "Copied" : <Copy size={14} />}</button>
        <a href={path} target="_blank" rel="noreferrer" className="btn-primary text-xs !px-3">Open</a>
      </div>
    </div>
  );
}

export default function OverlaysTab({ auction }) {
  const base = `/overlay/${auction.id}`;
  return (
    <div className="space-y-4" data-testid="overlays-tab">
      <div className="label-mono">BROADCAST OVERLAYS · public read-only links (share safely)</div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <OverlayCard
          title="LED Screen"
          description="Full-screen player card optimized for 1920×1080 LED displays at the venue."
          path={`${base}/led`}
          Icon={MonitorPlay}
          testId="overlay-led"
        />
        <OverlayCard
          title="Live Streaming"
          description="Transparent-background overlay for OBS/vMix as a browser source. Alpha channel with lower-third card."
          path={`${base}/stream`}
          Icon={Broadcast}
          testId="overlay-stream"
        />
        <OverlayCard
          title="Auctioneer Screen"
          description="Read-only auctioneer view — current player, bidder, and next min bid. Great as a secondary monitor."
          path={`${base}/auctioneer`}
          Icon={User}
          testId="overlay-auctioneer"
        />
        <OverlayCard
          title="Team-Owner Board"
          description="Public combined view for all team owners — squads, available/unsold players, max bids and remaining budgets. One link to share with every owner."
          path={`${base}/team-owner`}
          Icon={UsersThree}
          testId="overlay-team-owner"
        />
        <OverlayCard
          title="Teams Balance Board"
          description="Scoreboard-style tabular view of all teams — Purse / Balance / Max Bid / Squad. Toggle players with images + prices. Great for a side screen."
          path={`${base}/teams-balance`}
          Icon={Table}
          testId="overlay-teams-balance"
        />
        <OverlayCard
          title="Team Cycle (one-at-a-time)"
          description="Full-screen showcase that walks through each team one-by-one with logo, budget, max-bid and their full squad photos. Use arrow keys or autoplay."
          path={`${base}/team-cycle`}
          Icon={SlidersHorizontal}
          testId="overlay-team-cycle"
        />
      </div>
    </div>
  );
}
